import { render, staticRenderFns } from "./MStoreInputInlineUpdate.vue?vue&type=template&id=48fb2a87&scoped=true&"
import script from "./MStoreInputInlineUpdate.vue?vue&type=script&lang=ts&"
export * from "./MStoreInputInlineUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./MStoreInputInlineUpdate.vue?vue&type=style&index=0&id=48fb2a87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fb2a87",
  null
  
)

export default component.exports